import { render } from "./BadgeCellRenderer.vue?vue&type=template&id=6ae3ea56"
import script from "./BadgeCellRenderer.vue?vue&type=script&lang=js"
export * from "./BadgeCellRenderer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__